export default "__VITE_ASSET__BhaLrYS___"